import * as React from 'react';

function SvgTreeFill(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M8.416.223a.5.5 0 00-.832 0l-3 4.5A.5.5 0 005 5.5h.098L3.076 8.735A.5.5 0 003.5 9.5h.191l-1.638 3.276a.5.5 0 00.447.724H7V16h2v-2.5h4.5a.5.5 0 00.447-.724L12.31 9.5h.191a.5.5 0 00.424-.765L10.902 5.5H11a.5.5 0 00.416-.777l-3-4.5z' />
		</svg>
	);
}

export default SvgTreeFill;
